import React, {FC, RefObject, useState} from 'react'
import Button from '../UI/button/Button';
import styles from './ButtonsGroup.module.scss';
import Link from 'next/link';

type TButtonsGroup = {
    code: string | null
    url: string
    inputRef: RefObject<HTMLInputElement> | null;
    className?: string
    shortUrl: string
}

const ButtonsGroup: FC<TButtonsGroup> = ({code, inputRef, className, shortUrl}) => {
    const [copied, setCopied] = useState(false)

    const copyToClipboard = () => {
        if (inputRef && inputRef.current) {
            inputRef.current?.select();
            inputRef.current?.setSelectionRange(0, 99999);
            navigator.clipboard.writeText(inputRef.current.value);
            setCopied(true)
            setTimeout(() => setCopied(false), 5000); 
        }
    };
    return (
        <>
            <div className={`${styles.buttons__wrapper} ${className}`}>
            { code 
                &&  <div className={styles.copy__wrapper}>
                        <input readOnly value={code} className={styles.copy__input} ref={inputRef} aria-label={code}/>
                        <Button 
                            ariaLabel='Copy'
                            className={styles.copy__button}
                            onClick={copyToClipboard}
                        >
                            {copied ? 'Copied!' : 'Copy'}
                        </Button>
                    </div>}
                <Link
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    href={`${process.env.NEXT_PUBLIC_BASE_URL}/goto/${shortUrl}/`}
                    className={styles.button__link}
                >
                    Get Bonus
                </Link>
            </div>
        </>)
}

export default ButtonsGroup